import React, { useCallback, useState } from "react";
import { useDropzone } from "react-dropzone";
import { UploadCloud, Trash2 } from "lucide-react";

const InputDropFile = ({
  name,
  label,
  onChange,
  multiple = false,
  acceptFile = {
    "application/pdf": [".pdf"],
    "application/msword": [".doc"],
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [
      ".docx",
    ],
    "text/plain": [".txt"],
    "text/csv": [".csv"],
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [
      ".xlsx",
    ],
  },
}) => {
  const [uploadedFiles, setUploadedFiles] = useState([]);

  // Handle file drop
  const onDrop = useCallback(
    (acceptedFiles) => {
      setUploadedFiles((prevFiles) => [...prevFiles, ...acceptedFiles]);
      onChange &&
        onChange({ name, value: [...uploadedFiles, ...acceptedFiles] });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [onChange, uploadedFiles]
  );

  // Remove a file
  const removeFile = (fileName) => {
    const updatedFiles = uploadedFiles.filter((file) => file.name !== fileName);
    setUploadedFiles(updatedFiles);
    onChange && onChange({ name, value: updatedFiles });
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: acceptFile,
    multiple,
  });

  return (
    <div className="max-w-lg mx-auto p-4 bg-white rounded-[15px] shadow-md border border-gray-200">
      {(multiple || uploadedFiles.length <= 0) && (
        <div
          {...getRootProps()}
          className={`border-2 border-dashed rounded-lg p-6 flex flex-col items-center justify-center cursor-pointer transition-all ${
            isDragActive ? "border-blue-500 bg-blue-50" : "border-gray-300"
          }`}
        >
          <input {...getInputProps()} />
          <UploadCloud className="w-10 h-10 text-gray-500 mb-2" />
          <p className="text-gray-600">
            {isDragActive
              ? "Drop your files here..."
              : "Drag & drop files here or click to upload"}
          </p>
          <p className="text-xs text-gray-400">Accepted: XLSX</p>
        </div>
      )}

      {uploadedFiles.length > 0 && (
        <div className="mt-4">
          <h3 className="text-lg font-medium">Uploaded Files</h3>
          <ul className="mt-2 space-y-2">
            {uploadedFiles.map((file) => (
              <li
                key={file.name}
                className="flex items-center justify-between p-2 bg-gray-100 rounded-md text-sm text-gray-700"
              >
                <span className="truncate w-4/5">{file.name}</span>
                <button
                  onClick={() => removeFile(file.name)}
                  className="text-red-500 hover:text-red-700 transition-all"
                >
                  <Trash2 className="w-5 h-5" />
                </button>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default InputDropFile;
